import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import { useMemo } from 'react';
import useServices from '../../hooks/useServices';

var ServiceDashboard = /*#__PURE__*/function (_Service) {
  _inherits(ServiceDashboard, _Service);

  var _super = _createSuper(ServiceDashboard);

  function ServiceDashboard() {
    _classCallCheck(this, ServiceDashboard);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceDashboard, [{
    key: "rwMemberStats",
    value: function rwMemberStats(csmId) {
      return this.axiosInstance.get(ENDPOINTS.dashboard.rwMemberStats, {
        params: {
          csm_id: csmId
        }
      });
    }
  }, {
    key: "historyActiveJobPositions",
    value: function historyActiveJobPositions(_ref) {
      var jobPositionBillingType = _ref.jobPositionBillingType,
          timeFrame = _ref.timeFrame,
          timeRange = _ref.timeRange,
          csmId = _ref.csmId;
      return this.axiosInstance.get(ENDPOINTS.dashboard.historyActiveJobPositions, {
        params: {
          duration: timeRange,
          csm_id: csmId,
          time_frame: timeFrame,
          job_position_billing_type: jobPositionBillingType
        }
      });
    }
  }, {
    key: "getAssistanceSatisfactionStatistics",
    value: function getAssistanceSatisfactionStatistics(_ref2) {
      var timeFrame = _ref2.timeFrame,
          timeRange = _ref2.timeRange,
          csmId = _ref2.csmId;
      return this.axiosInstance.get(ENDPOINTS.dashboard.historyActiveJobPositions, {
        params: {
          duration: timeRange,
          csm_id: csmId,
          time_frame: timeFrame
        }
      });
    }
  }, {
    key: "csmWinRate",
    value: function csmWinRate(csmId) {
      return this.axiosInstance.get(ENDPOINTS.dashboard.csmWinRate, {
        params: {
          csm_id: csmId
        }
      });
    }
  }, {
    key: "workersShortlistsSent",
    value: function workersShortlistsSent(csmId) {
      return this.axiosInstance.get(ENDPOINTS.dashboard.averageShortlistsAndWorkersSent, {
        params: {
          csm_id: csmId
        }
      });
    }
  }, {
    key: "jpAvgClosingTime",
    value: function jpAvgClosingTime(csmId) {
      return this.axiosInstance.get(ENDPOINTS.dashboard.jobPositionAverageClosingTime, {
        params: {
          csm_id: csmId
        }
      });
    }
  }]);

  return ServiceDashboard;
}(Service);

export function useDashboardService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceDashboard(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useDashboardService;
export * from './types';